<template>
    <el-dialog :title="'产品转移-'+ warehouseName" :visible.sync="productTransferDialog" width="800px" :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-form-dialog custom-inventory-dialog">
        <div class="product_transfer_wrap">
            <el-form ref="formData" :rules="formRules" :model="formData" label-position="top">
                <el-form-item label="转入仓库" prop="in_stock_id">
                    <el-select v-model="formData.in_stock_id" clearable  filterable  placeholder="请输入或选择仓库名称" remote reserve-keyword>
                        <el-option :key="item.id" :disabled="item.id == warehouseId" :label="item.name" :value="item.id"  v-for="item in stockList"> </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="" prop="productData" >
                    <el-table class="custom_table" :data="formData.productData" border  ref="table"  >
                        <el-table-column label="产品名称" prop="name"    class-name=" tableInputColumn"	 width="285px">
                            <template slot-scope="{row,$index}">
                                <div v-if="row.is_edit" class="product_name_flex">
                                    <el-autocomplete size="small" v-model="row.name" value-key="name"  :fetch-suggestions="(queryString, cb) => getProductRemoteMethod(queryString, cb, row)" placeholder="请输入产品名称" @blur="handleBlurSelectProduct(row)" @select="handleSelectProduct($event,row)">
                                        <template slot-scope="{ item }">
                                            <div class="flex_js_wrap" :class="{ 'disabled-item':  item.disabled }">
                                                <div class="product_name ellipsis">{{ item.name }}</div>
                                                <div class="product_tag" v-if="item.disabled">无库存</div>
                                            </div>
                                        </template>
                                    </el-autocomplete>
                                    <span class="handle_icon_wrap" @click="handleClickSelectProduct(row,$index)">
                                        <i class="iconfont icon-cangku1"></i>
                                    </span>
                                </div>
                                <div v-else class="ellipsis" v-text="row.name"></div>
                            </template>
                        </el-table-column>
                        <el-table-column label="库存数量" prop="total_num" show-overflow-tooltip	align="right" width="88px">
                            <template slot-scope="{row}">
                                <span v-if="row.stock_info" v-text="row.stock_info.total_num ? row.stock_info.total_num : '系统带出'"></span>
                            </template>
                        </el-table-column>
                        <el-table-column label="转出数量\产品编码" prop="id" min-width="142px"  class-name=" tableInputColumn">
                            <template slot-scope="{row}">
                                <div class="product_num_code">
                                    <el-input type="mini" v-model="row.no_code_num" :disabled="row.stock_info.no_code_num > 0 ? false :true" placeholder="请输入数量" @change="handleChangeNum(row)"></el-input>
                                    <div class="line"></div>
                                    <div class="change_code">
                                        <el-popover  placement="bottom"  popper-class="product_code_popper" title=""  width="226"  trigger="hover">
                                            <span class="change_code_wrap" slot="reference" @click="handleClickSelectCode(row)">
                                               <i class="el-icon-circle-plus-outline"></i>
                                               <span>选择编码</span>
                                            </span>
                                            <div class="product_code_wrap">
                                                <ul>
                                                    <li class="ellipsis" v-for="item in row.code_list" v-text="item.code"></li>
                                                </ul>
                                                <div class="code_num_wrap">
                                                    共：{{ row.code_list.length}}条
                                                </div>
                                            </div>
                                        </el-popover>
                                    </div>
                                    <div class="total_num">
                                        共<span v-if="row.total_num" v-text="row.total_num"></span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="58" align="center">
                            <template slot-scope="{row,$index}">
                              <span class="handle_icon_wrap handle_icon_danger_wrap" @click="handleClickDel(row,$index)">
                                  <i class="iconfont icon-shanchu1"></i>
                              </span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="add_product_btn">
                        <span @click="handleClickAdd"><i class="el-icon-plus"></i>新增行</span>
                    </div>
                </el-form-item>

                <el-form-item label="备注" prop="note">
                    <el-input size="small" v-model="formData.note" type="textarea" :rows="4"  maxlength="200" show-word-limit placeholder="请输入备注"></el-input>
                </el-form-item>

            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" :disabled="BtnDisabled" @click.stop="handleDialogConfirm" >确定</el-button>
        </span>

        <SelectCode :selectCodeDialog.sync="selectCodeDialog" v-if="selectCodeDialog"  :productInfo="productInfo" @success="selectCodeSuccess"></SelectCode>
        <SelectProductTransfer :selectProductTransferDialog.sync="selectProductTransferDialog" v-if="selectProductTransferDialog" :warehouseId="warehouseId" :selectData="formData.productData" @success="selectProductSuccess"/>
    </el-dialog>
</template>
<script>
import { stockTransfer,stockList,searchOutProducts,chooseCode } from "@/api/index.js"
import SelectCode from  "../../component/select_code"
import SelectProductTransfer from  "../../component/select_product_transfer"
export default {
    name: "product_transfer",
    components: {
        SelectCode,
        SelectProductTransfer
    },
    props: {
        warehouseId: {
            type: Number,
            default: 0
        },
        warehouseName: {
            type: String,
            default: ''
        },
        productTransferDialog: {
            type: Boolean,
            default: false
        },
        transferProductData:{
            type:Array,
            default:() => []
        }

    },
    data() {
        return {
            BtnDisabled:false,
            formData: {
                in_stock_id: "",
                note:"",
                productData:[
                    {
                        stock_id:'',
                        sku_id:'',
                        sku_key:'',
                        name:'',
                        unit:'',
                        stock_info:{
                            code_num:0,
                            no_code_num:0,
                            total_num:0
                        },
                        code_num:0,
                        no_code_num:0,
                        total_num:0,
                        code_list:[],
                        is_edit:true
                    }
                ]
            },
            formRules: {
                in_stock_id: [
                    {required: true, message: "请输入或选择仓库名称",trigger: 'change'}
                ]
            },
            productList: [],
            stockList:[],
            selectCodeDialog:false,
            productInfo:null,//选中的产品
            productIndex:null,
            selectProductTransferDialog:false,//选择出库产品
        }
    },
    created() {
        if(this.transferProductData && this.transferProductData.length){
            this.formData.productData = this.transferProductData.map((item)=>{
                return {
                    stock_id:this.warehouseId,
                    sku_id:item.sku_id,
                    sku_key:item.sku_key,
                    name:item.name,
                    unit:item.unit,
                    stock_info:{
                        code_num:item.code_num,
                        no_code_num:item.no_code_num,
                        total_num:item.total_num,
                    },
                    code_num:0,
                    no_code_num:0,
                    total_num:0,
                    code_list:[],
                }
            })
        }else{
            this.formData.productData[0].stock_id = this.warehouseId
        }
        this.getStockList()
    },
    methods: {
        // 获取仓库
        getStockList(){
            stockList({}).then(res => {
                if (res.code === 200) {
                    this.stockList = res.data
                }
            })
        },

        // 获取产品
        getProductRemoteMethod(queryString, cb, row){
            let postData  = {
                keyword:queryString,
                stock_id:this.warehouseId
            }
            searchOutProducts(postData).then(res => {
                if (res.code === 200) {
                    let data = res.data ? res.data.map((item)=>{
                        item.disabled = !item.stocks.find(find => find.id == this.warehouseId).total_num ? true : false
                        return item
                    }) : []
                    this.productList = data
                    cb(data);
                }
            })
        },

        handleBlurSelectProduct(row){
            let info = this.productList.find(find => find.name == row.name)
            if(!info){
                this.$set(row,'name','')
                this.$set(row,'sku_id','')
                this.$set(row,'sku_key','')
                this.$set(row,'unit','个')
                this.$set(row,'stock_info',{
                    code_num:0,
                    no_code_num:0,
                    total_num:0
                })
                this.$set(row,'code_num',0)
                this.$set(row,'no_code_num',0)
                this.$set(row,'total_num',0)
            }else{
                this.handleSelectProduct(info,row)
            }
        },
        // 选择产品
        handleSelectProduct(event,row){
            if(this.formData.productData.filter(find=> find.name == event.name).length>1){
                this.$message.error(`${event.name}已存在`)
                this.$set(row,'name','')
                return false
            }
            let info = this.productList.find(find => find.name == event.name)
            if(info.disabled){
                this.$message.error(`该产品无库存`)
                this.$set(row,'name','')
                return false
            }
            this.$set(row,'sku_id',info.sku_id)
            this.$set(row,'sku_key',info.sku_key)
            this.$set(row,'unit',info.unit)
            if(this.warehouseId){
                let stock_info = event.stocks.find(find => find.id == this.warehouseId)
                if(stock_info){
                    this.$set(row,'stock_info',{
                        code_num:stock_info.code_num,
                        no_code_num:stock_info.no_code_num,
                        total_num:stock_info.total_num,
                    })
                    this.$set(row,'code_num',0)
                    this.$set(row,'no_code_num',0)
                    this.$set(row,'total_num',0)
                }else{
                    this.$set(row,'stock_info',{
                        code_num:0,
                        no_code_num:0,
                        total_num:0
                    })
                    this.$set(row,'code_num',0)
                    this.$set(row,'no_code_num',0)
                    this.$set(row,'total_num',0)
                }
            }
        },
        // 删除
        handleClickDel(row,index){
            if(this.formData.productData.length == 1) return this.$message.error('当前数据行不可删除，最少保留一行')
            this.formData.productData.splice(index,1)
        },
        // 新增行
        handleClickAdd(){
            let json = {
                stock_id:this.warehouseId,
                sku_id:'',
                sku_key:'',
                name:'',
                unit:'',
                stock_info:{
                    code_num:0,
                    no_code_num:0,
                    total_num:0
                },
                code_num:0,
                no_code_num:0,
                total_num:0,
                code_list:[],
                is_edit:true
            }
            this.formData.productData.push(json)
        },
        // 输入数量
        handleChangeNum(row){
            const num = row.no_code_num;
            const regex = /^[1-9]\d*$/; // 正整数的正则表达式
            if (!regex.test(num)) {
                this.$set(row,'no_code_num',0)
            } else {
                // // 如果输入的数量大于总数量则等于总数量
                if(row.no_code_num > row.stock_info.total_num){
                    this.$set(row,'no_code_num',row.stock_info.total_num)
                }
                // // 如果输入的数量大于无编码总数量则等于无编码总数量  并把多余的数量变为有编码的
                if(row.no_code_num > row.stock_info.no_code_num){
                    let remaining =  row.no_code_num  - row.stock_info.no_code_num // 多余的数量
                    this.$set(row,'no_code_num',row.stock_info.no_code_num)
                    this.automatic_replenishment(row,remaining) //自动补充编码
                }else{
                    this.$set(row,'total_num',Number(row.code_num) + Number(row.no_code_num))
                }

            }
            this.$set(row,'total_num',Number(row.code_num) + Number(row.no_code_num))
        },
        // 自动补充编码
        automatic_replenishment(row,remaining){
            let postData = {
                page: 1,
                pageSize: remaining + row.code_list.length, // 需要自动选择的编码+已经选择了的编码
                product_name:row.name,
                sku_id:row.sku_id,
                stock_id:this.warehouseId,
                keyword: ''
            }
            chooseCode(postData).then(res => {
                if (res.code === 200) {
                    let {list, total} = res.data
                    // 创建一个包含 code 中现有的集合以便快速查找
                    const existingCodes = new Set(row.code_list.map(item => item.code));
                    // 过滤 list，获取不在 code_list 中的值  并且状态是正常的编码
                    const filteredList = list.filter(item => !existingCodes.has(item.code) && item.status == 0);
                    // 从过滤后的列表中添加 'remaining' 个到 code_list中
                    row.code_list.push(...filteredList.slice(0, remaining));
                    this.$set(row,'code_num',row.code_list.length)
                    this.$set(row,'total_num',Number(row.code_num) + Number(row.no_code_num))
                    const h = this.$createElement;
                    this.$msgbox({
                        title: '库存数量已自动补充',
                        message: h('div', null, [
                            h('span', null, '此产品无编码数量不足，已为您使用无编码与有编码组合，系统将自动选择有编码产品！'),
                        ]),
                        iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                        customClass: 'prompt_message_custom',
                        confirmButtonText:  '知道了' ,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        showCancelButton: false,
                        confirmButtonClass: 'el-button--primary',
                        beforeClose: (action, instance, done) => {
                            if (action === 'confirm') {
                                done();
                            } else {
                                done();
                            }
                        }
                    }).then(() => {

                    }).catch(() => {

                    })
                }else{
                    this.btnDisabled = false
                }
            })
        },
        // 选择产品编码
        handleClickSelectCode(row){
            if(!row.name){ return this.$message.error('请先选择产品')}
            if(row.stock_info && row.stock_info.code_num == 0){
                return this.$message.error('该产品在该库中无编码产品')
            }
            this.productInfo = row
            this.selectCodeDialog = true
        },
        // 选择编码后回调
        selectCodeSuccess(data){
            this.$set(this.productInfo,'code_list',data)
            this.$set(this.productInfo,'code_num',this.productInfo.code_list.length)
            this.$set(this.productInfo,'total_num',Number(this.productInfo.code_num) + Number(this.productInfo.no_code_num))
        },
        // 选择产品
        handleClickSelectProduct(row,index){
            this.productIndex = index
            this.selectProductTransferDialog = true
        },
        // 选择产品回调
        selectProductSuccess(data){
            let json = {
                stock_id:this.warehouseId,
                sku_id:data.sku_id,
                sku_key:data.sku_key,
                name:data.name,
                unit:data.unit,
                stock_info:{
                    code_num:data.code_num,
                    no_code_num:data.no_code_num,
                    total_num:data.total_num,
                },
                code_num:0,
                no_code_num:0,
                total_num:0,
                code_list:[],
                is_edit:true
            }
            this.$set(this.formData.productData,this.productIndex,JSON.parse(JSON.stringify(json)))
        },
        handleDialogClose() {
            if (this.formData.note || this.formData.in_stock_id || (this.formData.productData.length > 0 && this.formData.productData.filter(item => (item.name || item.total_num )).length>0 )){
                const h = this.$createElement;
                this.$msgbox({
                    title: '是否要取消编辑',
                    message: h('div', null, [
                        h('span', null, '取消后，编辑内容不保留，是否取消！'),
                    ]),
                    iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                    customClass: 'prompt_message_custom',
                    confirmButtonText:  '确定',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showCancelButton: true,
                    confirmButtonClass:  'el-button--primary',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            done();
                        } else {
                            done();
                        }
                    }
                }).then(() => {
                    this.$emit("update:productTransferDialog", false)
                }).catch(() => {
                })
            }else{
                this.$emit("update:productTransferDialog", false)
            }
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    let product_list = []
                    let flag = true
                    this.formData.productData.forEach((item)=>{
                        let data = {
                            stock_id: item.stock_id,
                            name: item.name,
                            sku_id: item.sku_id,
                            sku_key: item.sku_key,
                            unit: item.unit,
                            no_code_num: item.no_code_num,
                            code_num: item.code_num,
                            code_list: item.code_list.map(item => item.code),
                            total_num: item.total_num,
                            related_type:"",
                            related_id:0,
                        }
                        if(item.name){
                            if(!data.total_num && flag){
                                flag = false
                                return  this.$message.error(`${item.name}数量不可为0`)
                            }
                            product_list.push(data)
                        }
                    })
                    if(!flag){return false}
                    if(product_list.length == 0){
                        return  this.$message.error('请至少转移一个产品')
                    }

                    const h = this.$createElement;
                    this.$msgbox({
                        title: '转移产品',
                        message: h('div', null, [
                            h('span', null, '请仔细核对转移产品，提交后不可撤回。'),
                        ]),
                        iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                        customClass: 'prompt_message_custom',
                        confirmButtonText:  '确定',
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        showCancelButton: true,
                        confirmButtonClass:  'el-button--primary',
                        beforeClose: (action, instance, done) => {
                            if (action === 'confirm') {
                                done();
                            } else {
                                done();
                            }
                        }
                    }).then(() => {
                        let postData = {
                            product_list:product_list,
                            stock_type: "transfer",
                            in_stock_id:this.formData.in_stock_id,
                            note:this.formData.note
                        }
                        this.BtnDisabled = true
                        stockTransfer(postData).then(res=> {
                            if(res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: res.message,
                                    duration: 1500,
                                    onClose: () => {}
                                })
                                this.$emit("update:productTransferDialog", false)
                                this.$emit('success')
                                this.BtnDisabled = false
                            }else{
                                this.BtnDisabled = false
                            }
                        })
                    }).catch(() => {
                    })







                }
            })
        },

    }
}
</script>
<style  lang="scss" scoped>
@import "@/styles/inventory_management.scss";
</style>